module.exports = __webpack_public_path__ + "static/media/logo-transparent.4c02d2be.png";